import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import './LogoNav.css';

interface LogoNavProps {
  className?: string;
}

const LogoNav: React.FC<LogoNavProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className={`logo-nav ${className}`}>
      <button 
        className="logo-nav-button" 
        onClick={() => navigate('/')}
        aria-label={t.common.goHomeAria}
      >
        <img 
          src="/DES-20250328_Logo_v3_SS.png" 
          alt={t.common.appName}
          className="logo-nav-image"
        />
      </button>
    </div>
  );
};

export default LogoNav; 